module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-16.91eedc99.png";